import { render, staticRenderFns } from "./BlockEmbedPdf.vue?vue&type=template&id=59b08c1a&scoped=true"
import script from "./BlockEmbedPdf.vue?vue&type=script&lang=js"
export * from "./BlockEmbedPdf.vue?vue&type=script&lang=js"
import style0 from "./BlockEmbedPdf.vue?vue&type=style&index=0&id=59b08c1a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59b08c1a",
  null
  
)

export default component.exports